<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>Notification Settings</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                
                <v-col 
                    cols="12"
                    lg="3"
                    md="6"
                    sm="12"
                >
                    <label>Status Job</label>
                    <v-combobox
                        v-model="serviceProjectSetupRequest.statusJobSelected"
                        :items="listStatus" 
                        item-text="statusDescription"
                        item-value="id"
                        clearable
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="6"
                    sm="12"
                >
                    <label>Status Work Order</label>
                    <v-combobox
                        v-model="serviceProjectSetupRequest.statusWorkOrderSelected"
                        :items="listStatusWorkOrder" 
                        item-text="statusDescription"
                        item-value="id"
                        clearable
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col
                    cols="12"
                    lg="1"
                    md="2"
                    sm="12"
                >
                    <v-switch
                        v-model="serviceProjectSetupRequest.createToDo"
                        label="Create To Do?"
                        color="var(--color__main)"
                        :value=1
                    >
                    </v-switch>
                </v-col>
                <v-col
                    cols="12"
                    lg="1"
                    md="2"
                    sm="12"
                >
                    <v-switch
                        v-model="serviceProjectSetupRequest.sendEmail"
                        label="Send Email?"
                        color="var(--color__main)"
                        :value=1
                    >
                    </v-switch>
                </v-col>
                <v-col
                    cols="12"
                    lg="1"
                    md="2"
                    sm="12"
                >
                    <v-switch
                        v-model="serviceProjectSetupRequest.putOnHold"
                        label="Put Job on hold?"
                        color="var(--color__main)"
                        :value=1
                    >
                    </v-switch>
                </v-col>
                <v-col
                    cols="12"
                    lg="2"
                    md="2"
                    sm="12"
                >
                    <v-switch
                        v-model="serviceProjectSetupRequest.sendNotificationSupervisor"
                        label="Send Notification to Job Supervisor?"
                        color="var(--color__main)"
                        :value=1
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <label>Profile</label>
                    <v-combobox
                        v-model="serviceProjectSetupRequest.profileSelected"
                        :items="listProfile"
                        :rules=[validations.required]
                        item-text="name"
                        item-value="id"
                        clearable
                        single-line
                        outlined
                        @change="filterUser(); serviceProjectSetupRequest.listUserSelected = null"
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <label>User</label>
                    <v-combobox
                        v-model="serviceProjectSetupRequest.listUserSelected"
                        :items="listUser"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        clearable
                        single-line
                        outlined
                        dense
                    >
                        <template v-slot:prepend-item>
                            <v-list-item
                                ripple
                                @mousedown.prevent
                                @click="toggleUsers"
                            >
                                <v-list-item-action>
                                    <v-icon :color="listUser.length > 0 ? 'indigo darken-4' : ''">
                                        {{ iconUser }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Select All
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <label>Title</label>
                    <v-text-field
                        v-model="serviceProjectSetupRequest.title" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <label>Description</label>
                    <v-textarea
                        v-model="serviceProjectSetupRequest.description"
                        :rules=[validations.required]
                        single-line
                        rows="4"
                        row-height="30"
                        outlined
                    >
                    </v-textarea>
                </v-col>
            </v-row>

            <br />

            <ActionButtons
                :request="serviceProjectSetupRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";
    import { orderBy } from '@/utilities/Utils';

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons
        },

        data: () => ({

            validForm: true,

            serviceProjectSetupRequest: {
                id: 0,
                statusJobSelected: null,
                statusWorkOrderSelected: null,
                createToDo: null,
                sendEmail: null,
                putOnHold: null,
                sendNotificationSupervisor: null,
                profileSelected: null,
                idProfile: 0,
                listUserSelected: [],
                idUser: 0,
                title: "",
                description: ""
            },

            listStatus: [],
            listStatusWorkOrder: [],
            listUser: [],
            listUserClone: [],
            listProfile: [],
            
            loading: false,

            validations: {
                required: required,
            }
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            allUsers () {
                return this.serviceProjectSetupRequest.listUserSelected != null && 
                       this.serviceProjectSetupRequest.listUserSelected != undefined &&
                       this.serviceProjectSetupRequest.listUserSelected.length === this.listUser.length
            },

            someUsers () {
                return this.serviceProjectSetupRequest.listUserSelected != null && 
                       this.serviceProjectSetupRequest.listUserSelected != undefined &&
                       this.serviceProjectSetupRequest.listUserSelected.length > 0 && !this.allUsers
            },

            iconUser () {
                if (this.allUsers) return 'mdi-close-box'
                if (this.someUsers) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },

        props: {
            id: {
                default: 0
            }
        },

        methods: {

            toggleUsers () {
                this.$nextTick(() => {
                    if (this.allUsers) {
                        this.serviceProjectSetupRequest.listUserSelected = []
                    } else {
                        this.serviceProjectSetupRequest.listUserSelected = this.listUser.slice()
                    }
                })
            },

            async getLists() {
                const listStatus = await this.$store.dispatch("serviceModule/ListStatus");
                this.listStatus = listStatus.filter(sts => sts.id >= 3 && [4, 13].includes(sts.id) == false).sort((a, b) => { return orderBy(a, b, 0, 'id') });
                this.listStatusWorkOrder = await this.$store.dispatch("workOrderModule/ListStatus");
            },
            
            async getRegister() {
                if (this.id != 0) {

                    const response = await this.$store.dispatch("serviceProjectSetupModule/GetById", this.id);
                    this.serviceProjectSetupRequest = response.result;
                }
            },

            async filterUser () {

                this.showLoading();

                if (this.serviceProjectSetupRequest.profileSelected != null && this.serviceProjectSetupRequest.profileSelected != undefined) {
                    this.serviceProjectSetupRequest.idProfile = this.serviceProjectSetupRequest.profileSelected.id;
                    this.listUser = this.listUserClone.filter(usr => usr.idProfile == this.serviceProjectSetupRequest.idProfile)
                }

                if (this.serviceProjectSetupRequest.userResponsibleSelected != null && this.serviceProjectSetupRequest.userResponsibleSelected != undefined) {
                    this.serviceProjectSetupRequest.idUser = this.serviceProjectSetupRequest.userResponsibleSelected.id
                }

                this.hideLoading();
            },

            async loadProfilesAndUsers() {
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
                let listUser = await this.$store.dispatch("userModule/List");
                let idProfileSelected = 0;

                if (this.serviceProjectSetupRequest.profileSelected != null && 
                    this.serviceProjectSetupRequest.profileSelected != undefined && 
                    this.serviceProjectSetupRequest.profileSelected.id != 0) {
                    idProfileSelected = this.serviceProjectSetupRequest.profileSelected.id;

                    listUser = listUser.filter(usr => usr.idProfile == idProfileSelected);
                }

                this.listUser = [...listUser];
                this.listUserClone = [...listUser];

                if (this.userLoggedGetters.listIDUsers != null && 
                    this.userLoggedGetters.listIDUsers != undefined &&
                    this.userLoggedGetters.listIDUsers.toString().trim() != '') {
                    const listIDUsers = this.userLoggedGetters.listIDUsers.toString().split(';');

                    let newListUsers = [];

                    listIDUsers.forEach(idUser => {

                        if (idUser != null && idUser != undefined && idUser.toString().trim() != '') {
                            const userFiltered = listUser.filter(item => item.id.toString() == idUser)[0];

                            if (userFiltered && userFiltered != null && userFiltered != undefined) {
                                newListUsers.push(userFiltered);
                                this.listUser = newListUsers;
                            }
                        }
                    });
                }
            },

            async cancel() {
                this.$router.push({ path: "/service/jobSetupList" });
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {
                    this.loading = true;
                    this.showLoading();

                    this.serviceProjectSetupRequest.id = this.id;

                    if (this.serviceProjectSetupRequest.statusJobSelected != null && this.serviceProjectSetupRequest.statusJobSelected != undefined) {
                        this.serviceProjectSetupRequest.statusJob = this.serviceProjectSetupRequest.statusJobSelected.id;
                    }
                    else {
                        this.serviceProjectSetupRequest.statusJob = -1;
                    }

                    if (this.serviceProjectSetupRequest.statusWorkOrderSelected != null && this.serviceProjectSetupRequest.statusWorkOrderSelected != undefined) {
                        this.serviceProjectSetupRequest.statusWorkOrder = this.serviceProjectSetupRequest.statusWorkOrderSelected.id;
                    }
                    else {
                        this.serviceProjectSetupRequest.statusWorkOrder = -1;
                    }

                    if (this.serviceProjectSetupRequest.createToDo === null) {
                        this.serviceProjectSetupRequest.createToDo = 0;
                    }

                    if (this.serviceProjectSetupRequest.sendEmail === null) {
                        this.serviceProjectSetupRequest.sendEmail = 0;
                    }

                    if (this.serviceProjectSetupRequest.putOnHold === null) {
                        this.serviceProjectSetupRequest.putOnHold = 0;
                    }

                    if (this.serviceProjectSetupRequest.sendNotificationSupervisor === null) {
                        this.serviceProjectSetupRequest.sendNotificationSupervisor = 0;
                    }

                    if (this.serviceProjectSetupRequest.profileSelected != null && this.serviceProjectSetupRequest.profileSelected != undefined) {
                        this.serviceProjectSetupRequest.idProfile = this.serviceProjectSetupRequest.profileSelected.id;
                    }

                    if (this.serviceProjectSetupRequest.listUserSelected != null && this.serviceProjectSetupRequest.listUserSelected != undefined) {
                        this.serviceProjectSetupRequest.listIDUser = '';

                        this.serviceProjectSetupRequest.listUserSelected.forEach(item => {
                            this.serviceProjectSetupRequest.listIDUser += `${item.id};`
                        });
                    }

                    const result = await this.$store.dispatch("serviceProjectSetupModule/CreateUpdate", this.serviceProjectSetupRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                }
            }
        },

        async created() {
            this.showLoading();

            await this.loadProfilesAndUsers();
            await this.filterUser();
            this.getLists();
            this.getRegister();

            this.hideLoading();
        }
    })
</script>
